define(function (require, exports, module) {
    var exists = require('extant/extant');

    var RX_KEY = /[\s]+/g;
    var UNDER = '_';
    var PREVIEW = 'preview';
    var LIVE = 'live';
    var FINAL = 'final';
    var OTHER = 'other';
    var F = 'F';
    var FSLASH = 'F/';
    var states = {
        preview: null,
        live: null,
        final: null
    };
    var internalStates = {
        live: LIVE,
        Live: LIVE,
        preview: PREVIEW,
        Preview: PREVIEW,
        pregame: PREVIEW,
        Pregame: PREVIEW,
        final: FINAL,
        Final: FINAL,
        wrapup: FINAL,
        Wrapup: FINAL
    };

    function statusToKey (status) {
        return (status + '').toLowerCase().replace(RX_KEY, UNDER);
    }

    exports.PREVIEW = PREVIEW;
    exports.LIVE = LIVE;
    exports.FINAL = FINAL;

    exports.init = function (statesObj) {
        var stateSet;
        var i;
        var len;
        for (var prop in statesObj) {
            stateSet = statesObj[prop];
            // make sure the prop group name matches one of our states
            if (!(prop === PREVIEW || prop === LIVE || prop === FINAL)) {
                prop = OTHER;
            }

            for (i = 0, len = stateSet.length; i < len; i++) {
                states[statusToKey(stateSet[i])] = prop;
            };
        }
    };

    exports.internalGameState = function (status) {
        return internalStates[status];
    };

    exports.getUsableGameState = function (status) {
        if (!exists(status)) {
            return OTHER;
        }

        status = status + '';
        // A litte unsure of this, but we need to treat two char values from
        // status_ind as a primary/secondary match against the character;
        var isInd = (status.length <= 2);
        var code = statusToKey(status);
        // Try for an exact match, or if it's in ind code match the primary
        var verify = states[code] || (isInd ? states[code.charAt(0)] : null);

        if (!exists(verify)) {
            return OTHER;
        } else {
            return verify;
        }
    };

    exports.getFinalState = function (status, scheduled, innings) {
        if (states[status] === FINAL && scheduled !== innings) {
            return FSLASH + innings;
        }

        return F;
    };

    exports.setGameState = function (state) {
        return internalStates[state] || PREVIEW;
    };
});
